import styled from 'styled-components/macro';
import { TYPOGRAPHY } from 'styleguide';

const ErrorMessage = styled.p`
  ${TYPOGRAPHY.body}
  color: #fff;
`;

export default ErrorMessage;
